import React, { useState, useEffect } from 'react';
import ClientAppShell from '../components/ClientAppShell';
import ClientProjectReportsPanel from '../components/client/ClientProjectReportsPanel';
import { usePageWalkthrough } from '../hooks/usePageWalkthrough';
import { useAuth } from '../auth/AuthContext';
import { markClientNavPageViewed } from '../utils/clientNavReadState';

const Reports = () => {
  const { user } = useAuth();
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const [userId, setUserId] = useState<number | string | null>(null);
  const [projectId, setProjectId] = useState<string | null>(null);

  const { walkthrough } = usePageWalkthrough({
    userId,
    parentId: 5,
    targetMap: {
      '[data-nav="reports"]': '[data-nav="reports"]',
    },
  });

  useEffect(() => {
    setProjectId(localStorage.getItem('projectId'));
    if (user?.userId) {
      setUserId(user.userId);
    }
  }, [user]);

  useEffect(() => {
    if (userId && projectId) {
      markClientNavPageViewed('reports', userId, projectId);
    }
  }, [userId, projectId]);

  return (
    <>
      {walkthrough}
      <ClientAppShell
        title="Reports"
        dataNav="reports"
        selectedItem={selectedItem}
        onMenuSelect={setSelectedItem}
        intro={{
          eyebrow: 'Project deliverables',
          description:
            'Open the evaluation prepared by your advisor—analysis, comparisons, and actionable recommendations for your next steps.',
        }}
      >
        <ClientProjectReportsPanel projectId={projectId} userId={userId} />
      </ClientAppShell>
    </>
  );
};

export default Reports;
